import React from 'react';

import { MonthPicker } from '@gogame/components';

import { omitFormProps } from '../utils';
import withFormField from './withFormField';

const MonthPickerField = withFormField()((props) => (
  <MonthPicker {...omitFormProps(props)} />
));

export default MonthPickerField;
